import { createFileRoute } from '@tanstack/react-router';
import { MewsTeam, RouteType } from '@mews/enums';
import { TextKey } from '@mews-commander/enums';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Finance/Cashier/_layout')({
    staticData: {
        owner: MewsTeam.Billing,
        type: RouteType.Frontend,
        title: TextKey.CashierPlural,
    },
});
